module.exports = __webpack_public_path__ + "img/wishlist-2@2x.1ce1679.png";